// ثبت اعتبار خارج از شمول
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { usePager, CountBadge } from '../../components/paging';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { jsonOf, netErr } from '../../utils/http';

const toFa   = n => String(n ?? '').replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng  = s => String(s ?? '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const fmtNum = n => n ? Number(n).toLocaleString('fa-IR') : '•';

const EMPTY = { program_id: 0, program: '', letter_no: '', letter_date: '', credit_pay: '', remark: '' };

const API = (path, opts = {}) => fetch(`/api/budget${path}`, {
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
  ...opts,
}).then(jsonOf, netErr);

function Lookup({ label, value, endpoint, onPick, flex = 1, disabled }) {
  const [q, setQ] = useState('');
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const search = async (text) => {
    setQ(text);
    const j = await API(`${endpoint}?q=${encodeURIComponent(text)}`);
    if (j.ok) { setRows(j.rows); setOpen(true); }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex, position: 'relative' }}>
      <label style={ui.mlabel}>{label}</label>
      <input value={value || q} onFocus={() => !disabled && search(q)} onChange={e => !disabled && search(e.target.value)}
        placeholder="جستجو..." disabled={disabled} style={{ ...ui.input, background: disabled ? '#f2f2f2' : '#fff' }} />
      {value && !disabled && <button onClick={() => { onPick({ id: 0, display: '' }); setQ(''); }}
        style={{ position: 'absolute', left: '6px', top: '30px', border: 'none', background: 'transparent', cursor: 'pointer', color: '#c62828', fontSize: '14px' }}>✕</button>}
      {open && rows.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', right: 0, left: 0, background: '#fff', border: '1px solid #e0e0e0',
          borderRadius: '8px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', zIndex: 700, maxHeight: '240px', overflowY: 'auto', marginTop: '2px' }}>
          {rows.map(r => (
            <div key={r.id} onClick={() => { onPick(r); setOpen(false); setQ(''); }}
              style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '12px', borderBottom: '1px solid #f0f0f0' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}>{r.display}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function BudgetProgramShomool({ user, onBack }) {
  // دکمه‌های فرم FRMPROGRAMSHOMOOL — دیدن دکمه = داشتن مجوز
  const vbf = useFormButtons('FRMPROGRAMSHOMOOL', ["BTNNEW","BTNEDIT","BTNDELETE","BTNOK"]);
  const curYear = new Date().toLocaleDateString('fa-IR').split('/')[0]
    .replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());

  const [year,   setYear]   = useState(curYear);
  const [search, setSearch] = useState('');
  const [data,     setData]     = useState([]);
  const pg = usePager();
  const [selected, setSelected] = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [modal,    setModal]    = useState(null);
  const [form,     setForm]     = useState(EMPTY);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const [toast,    setToast]    = useState('');

  const showToast = m => { setToast(m); setTimeout(() => setToast(''), 3000); };

  const cols = ['شماره نامه', 'تاریخ', 'برنامه / طرح', 'مبلغ اعتبار', 'جمع مصوب', 'جمع خارج از شمول', 'درصد', 'جمع هزینه', 'مانده هزینه', 'توضیح'];
  const initW = [110, 90, 240, 130, 130, 140, 70, 130, 130, 160];
  const [colW, setColW] = useState(initW);
  const colWRef = useRef(initW);
  useEffect(() => { colWRef.current = colW; }, [colW]);
  const startResize = useCallback((idx, e) => {
    e.preventDefault(); e.stopPropagation();
    const sx = e.clientX, sw = colWRef.current[idx];
    const onMove = ev => setColW(w => { const n = [...w]; n[idx] = Math.max(40, sw + (sx - ev.clientX)); return n; });
    const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  }, []);

  const load = useCallback(async (yr = year, page = 1) => {
    setLoading(true); setError(''); if (page === 1) setSelected(null);
    const j = await API(`/program-shomool/?year=${yr}&search=${encodeURIComponent(search)}&page=${page}`);
    setLoading(false);
    if (j.ok) setData(prev => pg.merge(prev, j, page));
    else setError(j.msg);
  }, [year, search, pg]);

  useEffect(() => { load(); }, []);

  const handleYear = e => {
    const v = toEng(e.target.value.replace(/[^0-9۰-۹]/g, '')).slice(0, 4);
    setYear(v);
    if (v.length === 4) load(v);
  };

  const F = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const openNew  = () => { if (!vbf.can('BTNNEW')) return; setForm(EMPTY); setError(''); setModal('new'); };
  const openEdit = () => { if (!vbf.can('BTNEDIT')) return;
    if (!selected) return;
    setForm({
      program_id: selected.program_id, program: selected.program, letter_no: selected.letter_no,
      letter_date: selected.letter_date, credit_pay: selected.credit_pay, remark: selected.remark,
    });
    setError(''); setModal('edit');
  };
  const openDel = () => { if (!vbf.can('BTNDELETE')) return; if (selected) setModal('delete'); };

  const save = async () => {
    setSaving(true); setError('');
    const body = JSON.stringify({ ...form, year });
    const j = modal === 'new'
      ? await API('/program-shomool/create/', { method: 'POST', body })
      : await API(`/program-shomool/${selected.id}/update/`, { method: 'PUT', body });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast(j.msg); load(); }
    else setError(j.msg);
  };

  const doDelete = async () => {
    setSaving(true);
    const j = await API(`/program-shomool/${selected.id}/delete/`, { method: 'DELETE' });
    setSaving(false);
    if (j.ok) { setModal(null); setSelected(null); showToast('حذف شد'); load(); }
    else setError(j.msg);
  };

  const toolbar = (
    <>
      <div style={ui.toolBtns}>
        {vbf.can('BTNNEW') && <button onClick={openNew} style={ui.btnNew}>＋ جدید</button>}
        {vbf.can('BTNEDIT') && <button onClick={openEdit} disabled={!selected} style={{ ...ui.btnEdit, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✎ ویرایش</button>}
        {vbf.can('BTNDELETE') && <button onClick={openDel} disabled={!selected} style={{ ...ui.btnDel, opacity: selected ? 1 : 0.4, cursor: selected ? 'pointer' : 'default' }}>✕ حذف</button>}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        <label style={ui.flabel}>سال مالی</label>
        <input value={toFa(year)} onChange={handleYear} maxLength={4} placeholder="۱۴۰۵" style={ui.yearInput} />
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()}
        style={{ ...ui.searchInput, flex: 1, minWidth: '150px' }} placeholder="جستجو (شماره، برنامه یا شرح)..." />
      {loading && <span>⏳</span>}
      <CountBadge shown={data.length} total={pg.total} loading={loading} />
    </>
  );

  return (
    <>
      <ListPage user={user} onBack={onBack} title="ثبت اعتبار خارج از شمول" subtitle="بخش بودجه — سامانه ارجان"
        toolbar={toolbar} error={!modal ? error : ''}
        pager={pg} loading={loading} onMore={p => load(year, p)}>
        <table style={{ ...ui.table, tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
            <tr>
              {cols.map((h, i) => (
                <th key={i} style={{ ...ui.th, width: colW[i], minWidth: 40, position: 'relative', userSelect: 'none' }}>
                  {h}<span onMouseDown={e => startResize(i, e)} style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', cursor: 'col-resize' }} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((r, i) => {
              const sel = selected?.id === r.id;
              const bg  = sel ? '#1a2f50' : i % 2 === 0 ? '#fff' : '#fdf6e3';
              const tc  = sel ? '#fff' : '#111';
              const num = (v, color) => <td style={{ ...ui.tdNum, color: sel ? '#fff' : v ? color : '#ccc' }}>{fmtNum(v)}</td>;
              return (
                <tr key={r.id} style={{ background: bg, cursor: 'pointer' }}
                  onClick={() => setSelected(sel ? null : r)} onDoubleClick={() => { setSelected(r); setTimeout(openEdit, 0); }}
                  onMouseEnter={e => { if (!sel) e.currentTarget.style.background = '#e8f0fe'; }}
                  onMouseLeave={e => { if (!sel) e.currentTarget.style.background = bg; }}>
                  <td style={{ ...ui.td, color: tc }}>{toFa(r.letter_no) || '•'}</td>
                  <td style={{ ...ui.td, fontFamily: 'monospace', fontSize: '11px', color: tc }}>{r.letter_date || '•'}</td>
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.program}>{r.program || '•'}</td>
                  {num(r.credit_pay, '#1b5e20')}
                  {num(r.sum_approved, '#1a237e')}
                  {num(r.sum_out_scope, '#6a1b9a')}
                  <td style={{ ...ui.tdNum, color: sel ? '#fff' : '#e65100', fontWeight: '700' }}>{toFa(r.percent)}٪</td>
                  {num(r.sum_havaleh, '#00695c')}
                  {num(r.remain_havaleh, r.remain_havaleh < 0 ? '#b71c1c' : '#1b5e20')}
                  <td style={{ ...ui.td, textAlign: 'right', fontSize: '11px', color: tc, overflow: 'hidden', textOverflow: 'ellipsis' }} title={r.remark}>{r.remark || '•'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!loading && data.length === 0 && <div style={ui.empty}>📭 داده‌ای یافت نشد</div>}
      </ListPage>

      {(modal === 'new' || modal === 'edit') && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '620px' }} onClick={e => e.stopPropagation()}>
            <div style={ui.mHeader}>
              <div style={ui.mTitle}>{modal === 'new' ? '＋ اعتبار خارج از شمول جدید' : '✎ ویرایش'}</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={ui.mBody}>
              {error && <div style={ui.errBox}>⚠️ {error}</div>}
              <div style={ui.row}>
                <Lookup label="برنامه / طرح" value={form.program} endpoint="/program-shomool/lookup/program/"
                  disabled={modal === 'edit'}
                  onPick={r => setForm(f => ({ ...f, program_id: r.id, program: r.display }))} flex={2} />
              </div>
              {modal === 'edit' && <div style={{ fontSize: '11px', color: '#888', marginTop: '-6px', marginBottom: '8px' }}>برنامه/طرح در ویرایش قابل تغییر نیست</div>}
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>شماره نامه</label>
                  <input value={form.letter_no} onChange={e => F('letter_no', e.target.value)} style={ui.input} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>تاریخ نامه</label>
                  <JalaliDatePicker value={form.letter_date} onChange={v => F('letter_date', v)} placeholder="تاریخ نامه" />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>مبلغ اعتبار (ریال)</label>
                  <input type="number" value={form.credit_pay} onChange={e => F('credit_pay', e.target.value)} style={ui.input} />
                </div>
              </div>
              <div style={ui.row}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
                  <label style={ui.mlabel}>توضیح</label>
                  <input value={form.remark} onChange={e => F('remark', e.target.value)} style={ui.input} />
                </div>
              </div>
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => { setModal(null); setError(''); }} style={ui.btnCancel}>انصراف</button>
              {vbf.can('BTNOK') && <button onClick={save} disabled={saving} style={ui.btnSave}>{saving ? '⏳ ...' : '💾 ذخیره'}</button>}
            </div>
          </div>
        </div>
      )}

      {modal === 'delete' && (
        <div style={ui.overlay} onClick={() => setModal(null)}>
          <div style={{ ...ui.modal, maxWidth: '440px' }} onClick={e => e.stopPropagation()}>
            <div style={{ ...ui.mHeader, background: 'linear-gradient(135deg,#b71c1c,#c62828)' }}>
              <div style={ui.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={() => setModal(null)} style={ui.closeBtn}>✕</button>
            </div>
            <div style={{ ...ui.mBody, textAlign: 'center', padding: '26px' }}>
              <div style={{ fontSize: '34px', marginBottom: '10px' }}>🗑️</div>
              {selected?.program}<br />مبلغ {fmtNum(selected?.credit_pay)} ریال
            </div>
            <div style={ui.mFooter}>
              <button onClick={() => setModal(null)} style={ui.btnCancel}>خیر</button>
              {vbf.can('BTNDELETE') && <button onClick={doDelete} disabled={saving} style={{ ...ui.btnSave, background: '#b71c1c' }}>{saving ? '⏳...' : 'بله، حذف'}</button>}
            </div>
          </div>
        </div>
      )}

      {toast && <div style={ui.toast}>{toast}</div>}
    </>
  );
}
